import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tcm-chat-icon-tszb",
  "use": "icon-tcm-chat-icon-tszb-usage",
  "viewBox": "0 0 28 27.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 27.999\" id=\"icon-tcm-chat-icon-tszb\">\r\n  <g transform=\"translate(-306 -81.885)\">\r\n    <g transform=\"translate(306 81.885)\">\r\n      <path class=\"b\" d=\"M17.54,23.163H15.832a3.1,3.1,0,0,1-3.085-3.109V17.413H10.124A3.1,3.1,0,0,1,7.039,14.3V8.863a3.1,3.1,0,0,1,3.085-3.109h2.623V3.109A3.1,3.1,0,0,1,15.832,0h5.4a3.1,3.1,0,0,1,3.085,3.109V5.754H26.94a3.1,3.1,0,0,1,3.085,3.109v1.994c-2.218-.063-11.706.372-12.485,12.305Z\" transform=\"translate(-7.039)\" />\r\n      <path class=\"b\" d=\"M456.263,475.9s-3.893-17.036,14.193-14.459c0,0,4.894,12-6.943,13.681C463.513,475.127,457.878,474.818,456.263,475.9Z\" transform=\"translate(-443.458 -448.788)\" />\r\n      <path class=\"b\" d=\"M463.228,735.274s3.349-8.1,9.028-7.681c0,0,.7.623-.348.869,0,0-4.012-.318-8.158,7.333Z\" transform=\"translate(-450.573 -707.797)\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tcm-chat-icon-tszb.svg
// module id = ehld
// module chunks = 10